import {ButtonBase, ButtonColors, ConcreteButtonProps} from "./button-base";
import React from "react";
import {observer} from "mobx-react-lite";
import {useServices} from "../../hooks/use-services.hook";


interface TertiaryButtonProps extends ConcreteButtonProps {
}

export const TertiaryButton: React.FC<TertiaryButtonProps> = observer((props) => {
    const services = useServices();
    const themeColors = services.theme.currentTheme.colors;

    const buttonColors: ButtonColors = {
        $background: themeColors.tertiary,
        $color: themeColors.tertiaryContrast,
        $border: themeColors.tertiary,
        $backgroundActivated: themeColors.tertiaryContrast,
        $colorActivated: themeColors.tertiary,
        $borderActivated: themeColors.tertiary
    }
    return (
        <ButtonBase {...props} colors={buttonColors}>
            {props.children}
        </ButtonBase>
    );
});
